import React, { useEffect, useRef, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "./VersionChip.css";

// Collapsed by default (just the info icon); click expands to show the build
// version. Used in the overview sidebar and the bottom-right canvas controls.
export const VersionChip: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!expanded) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expanded]);

  return (
    <div
      ref={ref}
      onClick={() => setExpanded((v) => !v)}
      className={`info-chip ${expanded ? "info-chip--expanded" : ""}`}
    >
      <div className="info-chip__text info-chip__text--left">
        <span>alpha {__APP_VERSION__}</span>
      </div>
      <InfoOutlinedIcon sx={{ fontSize: 14 }} />
    </div>
  );
};
